@if(labelName) {
	<label class="tglBtnLabel" [class.tglDisabled]="disabled">
		<ng-container *ngTemplateOutlet="template"></ng-container>
		<span [class]="labelCssClass">{{ labelName }}</span>
	</label>
} @else {
	<div (click)="toggle()" class="tglBtnLabel" [class.tglDisabled]="disabled">
		 <ng-container *ngTemplateOutlet="template"></ng-container>
	</div>
}

<ng-template #template>
	<input type="checkbox" class="tglInput visuallyHidden" [id]="toggleId" [(ngModel)]="value" [disabled]="disabled" [attr.aria-label]="ariaLabel" (ngModelChange)="onChange()">
	<div class="tglBtn">
		<div class="tglBtnTrack">
			<div class="check vb-icon vb-icon-round-check"></div>
		</div>
	</div>
</ng-template>
